module.exports = __webpack_public_path__ + "img/poro-coolguy.beb66385.png";